"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PDFControl = require("./PDFControl");
Object.keys(_PDFControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PDFControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PDFControl[key];
    }
  });
});